<template>
  <div>
    <a-row type="flex" class="simiot-margin-bottom-15px">
      <a-col flex="70px">
        <a-icon
          type="wallet"
          theme="twoTone"
          :style="{fontSize: '55px'}"
        />
      </a-col>

      <a-col flex="200px">
        <a-spin :spinning="loadingBalance">
          <a-statistic
            class="simiot-statistic"
            title="账户余额"
            prefix="￥"
            :precision="2"
            :value="balance"
          />
        </a-spin>
      </a-col>
    </a-row>

    <search-agent-balance-statistic @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button type="primary" @click="exportData">导出</a-button>
      </a-space>
    </div>

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loadingTable"
      :pagination="false"
      row-key="id"
    >
      <div slot="billable_no" slot-scope="billable_no, record">
        <a @click="showInfoModal(record)">{{ billable_no }}</a>
      </div>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchTableData"
    />

    <show-balance-statistic
      v-if="isShowInfoModal"
      :visible.sync="isShowInfoModal"
      :id="this.showingId"
      :billable-type="this.showingBillableType"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import SearchAgentBalanceStatistic from '@/views/balance_statistics/agent/Search'
import { findAgentBalanceStatistics, exportAgentBalanceStatistics } from '@/api/balance_statistic'
import ShowBalanceStatistic from '@/views/balance_statistics/agent/info'
import { findAgentFinanceOverview } from '@/api/agent'
import { formatFloat } from '@/utils/filter'
import { exportExcel } from '@/api/excel'

export default {
  name: 'AgentBalanceStatisticList',
  components: {
    ShowBalanceStatistic,
    SearchAgentBalanceStatistic,
    Pagination
  },
  data() {
    return {
      balance: undefined,
      data: [],
      loadingBalance: true,
      loadingTable: true,
      showingId: 0,
      showingBillableType: 0,
      isShowInfoModal: false,
      pagination: {
        total_count: 0
      },
      query: {
      }
    }
  },
  computed: {
    agentId() {
      return parseInt(this.$route.params.id)
    },

    columns() {
      return [
        {
          title: '时间',
          dataIndex: 'sort_time'
        },
        {
          title: '财务收支项',
          dataIndex: 'billable_type_display'
        },
        {
          title: '事件批次',
          scopedSlots: { customRender: 'billable_no' },
          dataIndex: 'billable_no'
        },
        {
          title: '金额(元)',
          customRender: formatFloat,
          dataIndex: 'total_fee'
        },
        {
          title: '余额(元)',
          customRender: formatFloat,
          dataIndex: 'balance'
        }
      ]
    }
  },
  created() {
    this.fetchBalanceStatistic()
    this.fetchTableData()
  },
  methods: {
    showInfoModal(record) {
      this.showingId = record.id
      this.showingBillableType = record.billable_type_slug
      this.isShowInfoModal = true
    },

    submitSearch(search) {
      // 赋值搜索条件，保留 per_page
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchTableData()
    },

    fetchBalanceStatistic() {
      this.loadingBalance = true
      findAgentFinanceOverview(this.agentId).then((res) => {
        if (res.code === 0) {
          this.balance = res.data.balance
        }
        this.loadingBalance = false
      })
    },

    fetchTableData() {
      this.loadingTable = true
      findAgentBalanceStatistics(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loadingTable = false
      })
    },

    exportData() {
      exportAgentBalanceStatistics(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        if (res.code === 0 && res.data.is_direct_download === true) {
          exportExcel(res.data.id, res.data.file_name)
        }
      })
    }
  }
}
</script>

